import { CallAPI } from './types'
import queryString from 'query-string'
import { decamelizeKeys, filterQueryParams } from '@/utils'

export const callApi: CallAPI = ky => {
  return {
    async history(params) {
      return await ky('call/', {
        method: 'get',
        searchParams: queryString.stringify(
          decamelizeKeys(filterQueryParams(params))
        )
      }).json()
    }
  }
}
